import { cn } from "@/lib/utils"

/**
 * Shell utility-bar icon/text triggers — brand-tinted sidebar-accent hover,
 * not generic `interactive-hover` (muted grey). Matches sidebar chrome +
 * `icon-button-chrome` token rules in `globals.css`.
 *
 * Always include `rounded-md` here so Link-based hits (Back, Help) match
 * `Button` ghost / `icon-sm` hover shape. Do not invent a second radius on
 * the bar.
 */
export const utilityBarActionButtonClass =
  "rounded-md bg-transparent icon-button-chrome hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:bg-sidebar-accent aria-expanded:bg-sidebar-accent aria-expanded:text-sidebar-accent-foreground"

export function utilityBarActionButtonClassName(...extra: Array<string | false | null | undefined>) {
  return cn(utilityBarActionButtonClass, ...extra)
}
